import { currencies } from '@/constants'
import { validateName } from '@/helpers'

import { addExtraNewBankAccountId } from './constants'

export const hasBankAccount = bankAccounts => {
  return localStorage.jwt && bankAccounts?.length > 0
}

export const hasNotBankAccount = bankAccounts => {
  return localStorage.jwt && !bankAccounts?.length
}

export const isFormValid = ({ context, firstName, lastName, bankAccount, newBankAccount, newBankAccountError }) => {
  if (hasNotBankAccount(context.bankAccounts) || bankAccount?.id === addExtraNewBankAccountId) {
    if (context.orderAmount.currency === currencies.EUR) {
      return (
        validateName(firstName) && validateName(lastName) && localStorage.jwt && newBankAccount && !newBankAccountError
      )
    } else if (context.orderAmount.currency === currencies.GBP) {
      return (
        validateName(firstName) &&
        validateName(lastName) &&
        localStorage.jwt &&
        newBankAccount?.sortCode?.length === 6 &&
        newBankAccount?.accountNumber?.length === 8 &&
        !newBankAccountError
      )
    }
  }

  return localStorage.jwt && bankAccount
}
